<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item :label="$t('报装类型')" prop="ticketsType">
              <!-- <j-dict-select-tag v-model="model.installationType" :dictCode="'installationType'"
                  :showSearch="false" placeholder="请选择报装类别" /> -->
              <a-select v-model="model.ticketsType" @change="installationTypeChange" :placeholder="$t('请选择报装类别')">
                <a-select-option :value="1">{{ $t('个人新装') }}</a-select-option>
                <a-select-option :value="6">{{ $t('企业新装') }}</a-select-option>
                <a-select-option :value="5">{{ $t('用水') }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
              <j-dict-select-tag
                v-model="model.ticketsEmergency"
                :placeholder="$t('请选择紧急程度')"
                dictCode="ticketsEmergency"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="model.ticketsType">
          <a-divider class="aDividerBlue" orientation="left">{{ $t('安装信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('区域信息')" prop="areaId">
                <SelectArea v-model="model.areaId" :area-path="model.areaName" @change="handleAreaChange" :level="3" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('用水地址')" prop="waterAddress">
                <!-- <a-input v-model.trim="model.waterAddress" placeholder="请输入用水地址"  ></a-input> -->
                <el-input
                  type="text"
                  size="small"
                  v-model.trim="model.waterAddress"
                  :placeholder="$t('请输入用水地址')"
                  maxlength="50"
                  show-word-limit
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('申请原因')" prop="reasonapplication">
                <!-- <a-textarea v-model.trim="model.reasonapplication" placeholder="请输入" :rows="4" :maxLength="100" /> -->
                <el-input
                  type="textarea"
                  :placeholder="$t('请输入')"
                  v-model.trim="model.reasonapplication"
                  :rows="4"
                  maxlength="100"
                  show-word-limit
                />
              </a-form-model-item>
            </a-col>
          </a-row>

          <!-- 个人新装 -->
          <a-row :gutter="24" v-if="model.ticketsType == 1">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('产权人信息') }}</a-divider>
            <!-- <a-col :span="8">
              <a-form-model-item label="报装编号" prop="installationNum">
                <a-input v-model="model.installationNum" placeholder="自动生成的报装编号" disabled  ></a-input>
              </a-form-model-item>
            </a-col> -->
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('产权人姓名')" prop="clientName">
                  <!-- <a-input v-model.trim="model.clientName" placeholder="请输入用户名称"  ></a-input> -->
                  <el-input
                    type="text"
                    size="small"
                    v-model.trim="model.clientName"
                    :placeholder="$t('请输入用户名称')"
                    maxlength="20"
                    show-word-limit
                    @change="inputName"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('产权人身份证号')" prop="identificationNumber">
                  <a-input v-model.trim="model.identificationNumber" :placeholder="$t('请输入身份证号')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('用户类别')" prop="clientType">
                  <a-select v-model="model.clientType" :placeholder="$t('请选择用户类别')">
                    <a-select-option v-for="(item, index) in clientTypeList" :value="item.id" :key="index">{{
                      item.utName
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="16">
                <a-form-model-item :label="$t('产权人身份证正反面')" prop="userIdCards">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的产权人身份证正反面')"
                    :isMultiple="true"
                    v-model="model.userIdCards"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('房产证')">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的房产证')"
                    :isMultiple="true"
                    v-model="model.userTitleDeed"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('联系人信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('是否委托')" prop="whetherEntrust">
                  <a-radio-group v-model="model.whetherEntrust" @change="handleChangeWhetherEntrust">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8" v-if="model.whetherEntrust == 1">
                <a-form-model-item :label="$t('联系人姓名')" prop="reportUserName">
                  <a-input v-model.trim="model.reportUserName" :placeholder="$t('请输入联系电话')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('联系人电话')" prop="phone">
                  <a-input v-model.trim="model.phone" :placeholder="$t('请输入联系电话')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="model.whetherEntrust == 1">
                <a-form-model-item :label="$t('委托书模版')" prop="contractAnnex">
                  <a href="#" @click.prevent="dowmloadTemp" style="text-decoration: underline"> {{ $t('委托书模版.pdf') }} </a>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="model.whetherEntrust == 1">
              <a-col :span="16">
                <a-form-model-item :label="$t('被委托人身份证正反面')" prop="reportUserIdCards">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('被委托人身份证正反面')"
                    :isMultiple="true"
                    v-model="model.reportUserIdCards"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('委托书')" prop="letterOfAuthorization">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('委托书')"
                    :isMultiple="true"
                    v-model="model.letterOfAuthorization"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('营业执照')" prop="businessLicense" :rules="businessLicenseRules">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的营业执照')"
                    :isMultiple="true"
                    v-model="model.businessLicense"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-row>

          <!-- 企业 -->
          <a-row :gutter="24" v-if="model.ticketsType == 5 || model.ticketsType == 6">
            <a-divider class="aDividerBlue" orientation="left">{{ $t('申请主体单位信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('单位名称')" prop="companyName">
                  <a-input v-model.trim="model.companyName" :placeholder="$t('请输入单位名称')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('单位地址')" prop="organizationAddress">
                  <a-input v-model.trim="model.organizationAddress" :placeholder="$t('请输入单位地址')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('统一社会信用代码')" prop="socialCreditCode">
                  <a-input v-model.trim="model.socialCreditCode" :placeholder="$t('请输入统一社会信用代码')"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('用户类别')" prop="clientType">
                  <a-select v-model="model.clientType" :placeholder="$t('请选择用户类别')">
                    <a-select-option v-for="(item, index) in clientTypeList" :value="item.id" :key="index">{{
                      item.utName
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('营业执照')" prop="businessLicense" :rules="businessLicenseRules">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的营业执照')"
                    :isMultiple="true"
                    v-model="model.businessLicense"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>

              <!-- <a-col :span="8">
                <a-form-model-item label="用户联系电话" prop="phone">
                  <a-input v-model.trim="model.phone" placeholder="请输入联系电话"  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="用水地址" prop="waterAddress">
                  <el-input type="text" size="small" v-model.trim="model.waterAddress" placeholder="请输入用水地址" maxlength="50" show-word-limit />
                </a-form-model-item>
              </a-col> -->
            </a-row>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('法人信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('法人姓名')" prop="corporationName">
                  <el-input
                    type="text"
                    size="small"
                    v-model.trim="model.corporationName"
                    :placeholder="$t('请输入法人姓名')"
                    maxlength="20"
                    show-word-limit
                    @change="inputName"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('身份证号码')" prop="identificationNumber">
                  <a-input v-model.trim="model.identificationNumber" :placeholder="$t('请输入身份证号码')"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="16">
                <a-form-model-item :label="$t('法人身份证正反面')" prop="userIdCards">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的法人身份证正反面')"
                    :isMultiple="true"
                    v-model="model.userIdCards"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('房产证')">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的房产证')"
                    :isMultiple="true"
                    v-model="model.userTitleDeed"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('联系人信息') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item :label="$t('是否委托')" prop="whetherEntrust">
                  <a-radio-group v-model="model.whetherEntrust" @change="handleChangeWhetherEntrust">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="8" v-if="model.whetherEntrust == 1">
                <a-form-model-item :label="$t('联系人姓名')" prop="clientName">
                  <a-input v-model.trim="model.clientName" :placeholder="$t('请输入联系人姓名')"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="8">
                <a-form-model-item :label="$t('联系人电话')" prop="phone">
                  <a-input v-model.trim="model.phone" :placeholder="$t('请输入联系电话')"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="8" v-if="model.whetherEntrust == 1">
                <a-form-model-item :label="$t('委托书模版')" prop="contractAnnex">
                  <a href="#" @click.prevent="dowmloadTemp" style="text-decoration: underline"> {{ $t('委托书模版.pdf') }} </a>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="model.whetherEntrust == 1">
              <a-col :span="16">
                <a-form-model-item :label="$t('被委托人身份证正反面')" prop="reportUserIdCards">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('被委托人身份证正反面')"
                    :isMultiple="true"
                    v-model="model.reportUserIdCards"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('委托书')" prop="letterOfAuthorization">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('委托书')"
                    :isMultiple="true"
                    v-model="model.letterOfAuthorization"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-divider class="aDividerBlue" orientation="left">{{ $t('申请公函') }}</a-divider>
            <a-row :gutter="24">
              <a-col :span="16">
                <a-form-model-item :label="$t('单位加盖公章申请书')" prop="companyApplicationForm">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('请上传清晰的单位加盖公章申请书')"
                    :isMultiple="true"
                    v-model="model.companyApplicationForm"
                  ></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-row>
        </div>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JUpload from '@/components/jeecg/JUpload'
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue, historyFileUrl, paramsToFormData } from '@/utils/util'
import { PhoneNumberPattern, CardIdNumberPattern } from '@/utils/regPattern'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import SelectArea from '../SelectArea.vue'

export default {
  name: 'ConstructionDetailForm',
  components: {
    JImageUpload,
    JUpload,
    SelectArea,
    JSelectUserByDep,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      // 初始化model对象，包含所有表单字段
      model: {
        ticketsType: undefined, // 报装类型
        ticketsEmergency: undefined, // 紧急程度
        areaId: undefined, // 区域信息
        areaName: undefined, // 区域信息
        waterAddress: '', // 用水地址
        reasonapplication: '', // 申请原因
        clientName: '', // 产权人/联系人姓名
        identificationNumber: '', // 身份证号
        clientType: undefined, // 用户类别
        userIdCards: '', // 产权人/法人身份证正反面
        userTitleDeed: '', // 房产证
        businessLicense: '', // 营业执照
        whetherEntrust: 0, // 是否委托（默认否）
        phone: '', // 联系电话
        reportUserName: '', // 委托人姓名
        reportUserIdCards: '', // 被委托人身份证正反面
        letterOfAuthorization: '', // 委托书
        companyName: '', // 单位名称（企业）
        organizationAddress: '', // 单位地址（企业）
        socialCreditCode: '', // 统一社会信用代码（企业）
        corporationName: '', // 法人姓名（企业）
        companyApplicationForm: '', // 单位加盖公章申请书
      },
      ticketsData: {}, // 工单数据
      confirmLoading: false,
      ticketsFrom: 'Installation',
      url: {
        // add: "/jeecg-engineering/engineering/installationDetail/add",
        // edit: "/jeecg-engineering/engineering/installationDetail/edit",
        add: '/jeecg-engineering/ticket/tickets/createTicket',
        edit: '/jeecg-engineering/ticket/tickets/newUpdate',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        upload: 'sys/common/upload',
        userType: '/jeecg-charge/meter/meterUserType/list',
      },
      fileList: [],
      clientTypeList: [],
      modelDefault: {},
      picture: '',
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      return {
        ticketsType: [{ required: true, message: this.$t('请选择报装类型') }],
        ticketsEmergency: [{ required: true, message: this.$t('请选择紧急程度'), trigger: ['blur', 'change'] }],
        areaId: [{ required: true, message: this.$t('请选择区域信息') }],
        corporationName: [{ required: true, message: this.$t('请输入法人姓名') }],
        clientName: [{ required: true, message: this.$t('请输入用户名称') }],
        companyName: [{ required: true, message: this.$t('请输入单位名称') }],
        organizationAddress: [{ required: true, message: this.$t('请输入单位地址') }],
        socialCreditCode: [{ required: true, message: this.$t('请输入统一社会信用代码') }],
        businessLicense: [{ required: true, message: this.$t('请上传营业执照') }],
        companyApplicationForm: [{ required: true, message: this.$t('请上传申请书') }],
        waterAddress: [{ required: true, message: this.$t('请输入用水地址') }],
        identificationNumber: [
          { required: true, message: this.$t('请输入身份证号') },
          { pattern: CardIdNumberPattern, message: this.$t('请输入正确的身份证号') },
        ],
        phone: [
          { required: true, message: this.$t('请输入联系电话') },
          { pattern: PhoneNumberPattern, message: this.$t('请输入正确的手机号码') },
        ],
        clientType: [{ required: true, message: this.$t('请选择用户类别') }],
        waterType: [{ required: true, message: this.$t('请输入用水类别') }],
        userIdCards: [{ required: true, message: this.$t('请上传身份证正反面') }],
        reportUserIdCards: [{ required: true, message: this.$t('请上传被委托人身份证正反面') }],
        userTitleDeed: [{ required: true, message: this.$t('请上传房产证') }],
        whetherEntrust: [{ required: true, message: this.$t('请选择是否委托') }],
        letterOfAuthorization: [{ required: true, message: this.$t('请上传委托书') }],
        reportUserName: [{ required: true, message: this.$t('请输入联系人姓名') }],
        //   createPhone: [{ required: true, message: '请输入报装联系人电话' },{pattern: PhoneNumberPattern,message: '请输入正确的手机号码'}],
      }
    },
    businessLicenseRules() {
      // 报装类型 为 个人用水
      if (this.model.ticketsType == '1') {
        return [{ required: false, message: this.$t('请上传营业执照'), trigger: 'change' }]
      } else {
        return [{ required: true, message: this.$t('请上传营业执照'), trigger: 'change' }]
      }
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = {}
    this.getUserType()
  },
  methods: {
    getUserType() {
      this.clientTypeList = []
      getAction(this.url.userType).then(res => {
        if (res.success) {
          res.result.records.map(item => {
            this.clientTypeList.push({
              utName: item.utName,
              id: item.id,
            })
          })
        }
      })
    },
    uploadChange(file) {
      this.model.letterOfAuthorization = file
      this.$refs.form.validateField('letterOfAuthorization')
    },
    // handleChange(info){
    //   const { fileList } = this;
    //   const formData = new FormData();
    //   fileList.forEach(file => {
    //     formData.append('file', file);
    //     formData.append('biz', 'temp');
    //   });
    //   postAction(this.url.upload,formData).then(res=>{
    //     if(res.success){
    //       this.model.annex = res.message;
    //     }
    //   });
    // },
    // beforeUpload (file) {
    //   this.fileList = [file];
    //   this.model.annexName = this.fileList[0].name;
    //   return false;
    // },
    // handleRemove (file) {
    //   const index = this.fileList.indexOf(file);
    //   const newFileList = this.fileList.slice();
    //   newFileList.splice(index, 1);
    //   this.fileList = newFileList;
    // },
    init() {
      this.model = {
        ticketsType: undefined, // 报装类型
        ticketsEmergency: undefined, // 紧急程度
        areaId: undefined, // 区域信息
        areaName: undefined, // 区域信息
        waterAddress: '', // 用水地址
        reasonapplication: '', // 申请原因
        clientName: '', // 产权人/联系人姓名
        identificationNumber: '', // 身份证号
        clientType: undefined, // 用户类别
        userIdCards: '', // 产权人/法人身份证正反面
        userTitleDeed: '', // 房产证
        businessLicense: '', // 营业执照
        whetherEntrust: 0, // 是否委托（默认否）
        phone: '', // 联系电话
        reportUserName: '', // 委托人姓名
        reportUserIdCards: '', // 被委托人身份证正反面
        letterOfAuthorization: '', // 委托书
        companyName: '', // 单位名称（企业）
        organizationAddress: '', // 单位地址（企业）
        socialCreditCode: '', // 统一社会信用代码（企业）
        corporationName: '', // 法人姓名（企业）
        companyApplicationForm: '', // 单位加盖公章申请书
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    add() {
      this.init()
    },
    edit(record) {
      let that = this
      this.init()
      this.visible = true

      if (record.id) {
        // 获取详情信息
        getAction(this.url.queryById, { id: record.id }).then(res => {
          if (res.success) {
            that.ticketsData = {
              ...res.result,
            }

            that.model = {
              ...res.result.installationDetail,
              id: res.result.id,
              ticketsForeignId: res.result.ticketsForeignId,
              ticketsNum: res.result.ticketsNum,
              ticketsEmergency: res.result.ticketsEmergency,
              ticketsState: res.result.ticketsState,
              ticketsType: res.result.ticketsType,
            }
            // 处理身份证图片 - 使用数组存储存在的图片
            const userIdCards = []
            if (that.model.userIdCardFront) userIdCards.push(that.model.userIdCardFront)
            if (that.model.userIdCardOpposite) userIdCards.push(that.model.userIdCardOpposite)
            if (userIdCards.length > 0) {
              this.$set(that.model, 'userIdCards', userIdCards.join(','))
            }

            // 处理被委托人身份证图片 - 使用数组存储存在的图片
            const reportUserIdCards = []
            if (that.model.reportUserIdCardFront) reportUserIdCards.push(that.model.reportUserIdCardFront)
            if (that.model.reportUserIdCardOpposite) reportUserIdCards.push(that.model.reportUserIdCardOpposite)

            if (reportUserIdCards.length > 0) {
              this.$set(that.model, 'reportUserIdCards', reportUserIdCards.join(','))
              this.$set(that.model, 'whetherEntrust', 1)
            } else {
              this.$set(that.model, 'whetherEntrust', 0)
            }
            console.log('是否临时用水', that.model.whetherUseWaterTemporarily)
            this.$set(that.model, 'whetherUseWaterTemporarily', that.model.whetherUseWaterTemporarily)
          }
        })
      }
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true

          let httpurl = ''
          let method = ''
          let message = ''

          let params = {
            ticketsFrom: that.ticketsFrom,
            ticketsType: that.model.ticketsType,
            ticketsEmergency: that.model.ticketsEmergency,
            dealTime: '',
            ticketsState: '',
            ticketsInstallationReq: {
              ...that.model,
            },
          }

          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
            message = this.$t('新增成功')
          } else {
            httpurl += this.url.edit
            method = 'put'
            message = this.$t('编辑成功')
            params.id = this.ticketsData.id
            params.ticketsForeignId = this.ticketsData.ticketsForeignId
          }

          if (that.model.userIdCards) {
            const [userIdCardFront, userIdCardOpposite] = that.model.userIdCards.split(',')
            params.ticketsInstallationReq.userIdCardFront = userIdCardFront

            params.ticketsInstallationReq.userIdCardOpposite = userIdCardOpposite
          }

          if (that.model.reportUserIdCards) {
            const [reportUserIdCardFront, reportUserIdCardOpposite] = that.model.reportUserIdCards.split(',')
            params.ticketsInstallationReq.reportUserIdCardFront = reportUserIdCardFront
            params.ticketsInstallationReq.reportUserIdCardOpposite = reportUserIdCardOpposite
          }

          console.log('当前参数params', params)
          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    installationTypeChange() {
      // 清空表单校验
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
      if (this.model.ticketsType == '1') {
        // 个人新装：清空企业相关字段
        this.model.companyName = ''
        this.model.organizationAddress = ''
        this.model.socialCreditCode = ''
        this.model.clientType = undefined
        this.model.corporationName = ''
        this.model.identificationNumber = ''
        this.model.userIdCards = ''
        this.model.companyApplicationForm = ''
      } else {
        // 企业新装或用水：清空个人新装特有字段
        this.model.clientName = ''
        this.model.identificationNumber = ''
        this.model.clientType = undefined
        this.model.userIdCards = ''
        this.model.userTitleDeed = ''
      }
      this.model.whetherEntrust = 0
      this.handleChangeWhetherEntrust()
    },
    handleChangeWhetherEntrust() {
      // this.model.phone = ''
      // // this.model.reportUserName = ''
      // this.model.reportUserIdCards = ''
      // this.model.letterOfAuthorization = ''
      // this.model.businessLicense = ''
      this.$set(this.model,'phone','');
      this.$set(this.model,'reportUserIdCards','');
      this.$set(this.model,'letterOfAuthorization','');
      this.$set(this.model,'businessLicense','');

      if(this.model.ticketsType == 1){
        if(this.model.whetherEntrust==0){
          this.$set(this.model,'reportUserName',this.model.clientName);
        }else{
          this.$set(this.model,'reportUserName','');
        }
			}else{
        if(this.model.whetherEntrust==0){
          this.$set(this.model,'clientName',this.model.corporationName);
        }else{
          this.$set(this.model,'clientName','');
        }
			}
    },
    handleAreaChange(result) {
      if (result) {
        this.model.areaId = result.id
        // 将路径信息存储到模型中，用于初始显示
        this.model.areaName = result.path
      } else {
        this.model.areaId = ''
        this.model.areaName = ''
      }
    },
    // 委托书模板下载
    dowmloadTemp() {
      // const templateUrl = '/templates/委托书模板.pdf'; // 模板文件路径
      // const downloadLink = document.createElement('a');
      // downloadLink.href = templateUrl;
      // downloadLink.target = '_blank';
      // downloadLink.download = '委托书模板.pdf'; // 下载文件名
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
      // document.body.removeChild(downloadLink);

      // 实际项目中应该使用API接口获取文件流
      window.open('http://120.71.183.37:3003/file/sqwt.docx')

      // this.$http.get('http://120.71.183.37:3003/file/sqwt.docx', {
      //   responseType: 'blob',
      //   params: { type: 'proxy' }
      // }).then(res => {
      //   const blob = new Blob([res.data]);
      //   const link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = '委托书模板.pdf';
      //   link.click();
      // });
    },
    handleTicketsEmergencyChange(value) {
      debugger
      // 手动触发紧急程度字段的校验
      this.$refs.form.validateField('ticketsEmergency')
    },
    inputName(e){
      if(this.model.ticketsType == 1){
        if(this.model.whetherEntrust==0){
          this.$set(this.model,'reportUserName',e);
        }
			}else{
        if(this.model.whetherEntrust==0){
          this.$set(this.model,'clientName',e);
        }
			}
    }
  },
}
</script>
<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
/* /deep/.jeecg-form-container-disabled .ant-upload-select{
    display: block;
 } */
</style>
